module.exports = __webpack_public_path__ + "07_face.120ced62.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/07_face.png
// module id = cRym
// module chunks = 0